import { Typography } from '@material-ui/core';

import { LeaderBoardIcon } from 'components';

import { useStyles } from './styles';

interface NoDataProps {
  title?: string;
  subtitle?: string;
  showTitle?: boolean;
  showSubtitle?: boolean;
  height?: number;
}

const defaultTitle = 'Não há dados para esse indicador';
const defaultSubtitle = 'Este indicador não foi abordado no questionário.';

export function NoData({
  height,
  title = defaultTitle,
  subtitle = defaultSubtitle,
  showTitle = true,
  showSubtitle = true,
}: NoDataProps): JSX.Element {
  const classes = useStyles();

  return (
    <div className={classes.root} style={{ minHeight: height }}>
      <div className={classes.noDataIconWrapper}>
        <LeaderBoardIcon className={classes.noDataIcon} />
      </div>
      {showTitle && (
        <Typography className={classes.title} variant="h5">
          {title}
        </Typography>
      )}
      {showSubtitle && (
        <Typography className={classes.subTitle} variant="subtitle1">
          {subtitle}
        </Typography>
      )}
    </div>
  );
}
